import { render, staticRenderFns } from "./editCommHome.vue?vue&type=template&id=f92f04f4&"
import script from "./editCommHome.vue?vue&type=script&lang=js&"
export * from "./editCommHome.vue?vue&type=script&lang=js&"
import style0 from "./editCommHome.vue?vue&type=style&index=0&id=f92f04f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports